import { registerDataGridSorterer } from "./DataGridRegistry.jsx";
import { WorkflowObjectState } from 'olympe';
import {BCP_WORKFLOW_ORDER} from '../../../common/section_bcp/BcpWorkflowAuthorizations';

/**
 * Sorterer used to sort if the values to compare are text,number,date,BCPWorkflow status
 * Sort function take two values when we click on data grid columns of text,number or date type 
 * Sort function take data grid execution context,two cloud object values when we click on data grid columns of BCPworkflow status type 
 * we will fetch the BCP_WORKFLOW_ORDER which is used to compare the values and sort it.
 * It will compare two values and sort it accordingly
 * once registerDataGridSorterer called it will go inside datagridRegistry and it will set the sorterer in DataGridRegistry
 * it will execute getDataGridSorterer based on the type of sorterer.
 */
registerDataGridSorterer({
    name:'Text',
    sort:(value1,value2)=>{
        return value1.localeCompare(value2)
    }
})

registerDataGridSorterer({
    name:'Number',
    sort:(value1,value2)=>{
        return(
            value1-value2
        )
    }
})

registerDataGridSorterer({
    name:'Date',
    sort:(value1,value2)=>{
     return (value1.getTime()-value2.getTime())
    }
})

registerDataGridSorterer({
    name:'BCPWorkflow',
    sort:(value1,value2,$,cloudObject1,cloudObject2)=>{
        const workflowState1 = $.get('Workflows').get(cloudObject1.getTag()).get(WorkflowObjectState.stateProp);
        const workflowState2 = $.get('Workflows').get(cloudObject2.getTag()).get(WorkflowObjectState.stateProp)
        const order1 = BCP_WORKFLOW_ORDER[workflowState1];
        const order2 = BCP_WORKFLOW_ORDER[workflowState2];
        return order1-order2;
    }
})
